import { Box, Typography } from "@mui/material";

export const INVESTMENT_HISTORY_HEAD = [
  {
    key: "coin",
    name: <>
      <Typography variant="h6">Coin</Typography>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 1.5 }}>
        <br />
      </Box>
    </>,
    align: "left",
  },
  {
    key: "portfolio",
    name: <>
      <Typography variant="h6">Portfolio</Typography>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 1.5 }}>
        <br />
      </Box>
    </>,
    align: "center",
  },
  {
    key: "deposit",
    name: (
      <>
        <Typography variant="h6">Deposit</Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 1.5 }}>
          <Typography variant="subtitle1" color="text.secondary">Amount</Typography>
          <Typography variant="subtitle1" color="text.secondary">Fee</Typography>
        </Box>
      </>
    ),
    align: "center",
  },
  {
    key: "investment",
    name: (
      <>
        <Typography variant="h6">Close Investment</Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 1.5 }}>
          <Typography variant="subtitle1" color="text.secondary" sx={{ flex: 1, textAlign: 'right' }}>Total</Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ flex: 1, textAlign: 'center' }}>Profit/Loss</Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ flex: 1, textAlign: 'left' }}>Fee</Typography>
        </Box>
      </>
    ),
    align: "center",
    display: 'block'
  },
  {
    key: "withdraw",
    name: (
      <>
        <Typography variant="h6">Withdraw Investment</Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 1.5 }}>
          <Typography variant="subtitle1" color="text.secondary">Amount</Typography>
        </Box>
      </>
    ),
    align: "center",
  },
  {
    key: "action",
    name: <>
      <Typography variant="h6">Action</Typography>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 1.5 }}>
        <br />
      </Box>
    </>,
    align: "center",
  },
];
